import { FormControl, FormLabel, Select, Text } from "@chakra-ui/react";
import { useReasonCodes } from "../../hooks/useReasonCodes";

/** B22 reason dropdown: shows the description, returns the long code. */
export const ReasonSelect = ({ label = "Reason", value, onChange, isRequired, ...props }) => {
  const { reasons, loading, error } = useReasonCodes();
  return (
    <FormControl isRequired={isRequired} {...props}>
      {label && <FormLabel fontSize="xs">{label}</FormLabel>}
      <Select
        size="sm"
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        placeholder={loading ? "Loading reasons…" : error ? "Couldn't load reasons" : isRequired ? "Choose a reason…" : "No reason code"}>
        {reasons.map((r) => (
          <option key={r.code} value={r.code}>{r.description}</option>
        ))}
      </Select>
    </FormControl>
  );
};

/**
 * A decline or NTU reason: the B22 description for `code`, then any free
 * text (`notes`) underneath. Renders nothing when there's neither.
 */
export const ReasonText = ({ code, notes, prefix, ...props }) => {
  const { describe } = useReasonCodes();
  if (!code && !notes) return null;
  return (
    <Text fontSize="xs" whiteSpace="pre-wrap" {...props}>
      {prefix}
      {code && <Text as="span" fontWeight="semibold">{describe(code)}</Text>}
      {code && notes && ": "}
      {notes}
    </Text>
  );
};
